import { render, staticRenderFns } from "./DpaNavigationStatic.vue?vue&type=template&id=09eb3cb8&"
import script from "./DpaNavigationStatic.vue?vue&type=script&lang=ts&"
export * from "./DpaNavigationStatic.vue?vue&type=script&lang=ts&"
import style0 from "./DpaNavigationStatic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports